import { Button, Icon } from '@iqueue/ui-kit'
import cn from 'classnames'

export default function ForbiddenError({ className }) {
  return <div className={ cn('iq-error-view center', className) }>
    <h1><Icon>privacy_tip</Icon></h1>
    <h3>У вас нет доступа к запрашиваемому ресурсу!</h3>

    <Button flat disabled>Запросить доступ</Button>
  </div>
}
